// Mock Bible Data Layer - All data structures for front-end only implementation
// This file provides mock data for books, chapters, verses, cross-references, and commentaries
// Replace these with real API calls when ready to integrate backend

// Bible Books List
export const BIBLE_BOOKS = {
  oldTestament: [
    { id: 'genesis', name: 'Genesis', abbrev: 'Gen', chapters: 50, testament: 'OT' },
    { id: 'exodus', name: 'Exodus', abbrev: 'Exod', chapters: 40, testament: 'OT' },
    { id: 'leviticus', name: 'Leviticus', abbrev: 'Lev', chapters: 27, testament: 'OT' },
    { id: 'numbers', name: 'Numbers', abbrev: 'Num', chapters: 36, testament: 'OT' },
    { id: 'deuteronomy', name: 'Deuteronomy', abbrev: 'Deut', chapters: 34, testament: 'OT' },
    { id: 'joshua', name: 'Joshua', abbrev: 'Josh', chapters: 24, testament: 'OT' },
    { id: 'judges', name: 'Judges', abbrev: 'Judg', chapters: 21, testament: 'OT' },
    { id: 'ruth', name: 'Ruth', abbrev: 'Ruth', chapters: 4, testament: 'OT' },
    { id: '1samuel', name: '1 Samuel', abbrev: '1 Sam', chapters: 31, testament: 'OT' },
    { id: '2samuel', name: '2 Samuel', abbrev: '2 Sam', chapters: 24, testament: 'OT' },
    { id: '1kings', name: '1 Kings', abbrev: '1 Kgs', chapters: 22, testament: 'OT' },
    { id: '2kings', name: '2 Kings', abbrev: '2 Kgs', chapters: 25, testament: 'OT' },
    { id: 'psalms', name: 'Psalms', abbrev: 'Ps', chapters: 150, testament: 'OT' },
    { id: 'proverbs', name: 'Proverbs', abbrev: 'Prov', chapters: 31, testament: 'OT' },
    { id: 'isaiah', name: 'Isaiah', abbrev: 'Isa', chapters: 66, testament: 'OT' },
    { id: 'jeremiah', name: 'Jeremiah', abbrev: 'Jer', chapters: 52, testament: 'OT' },
  ],
  newTestament: [
    { id: 'matthew', name: 'Matthew', abbrev: 'Matt', chapters: 28, testament: 'NT' },
    { id: 'mark', name: 'Mark', abbrev: 'Mark', chapters: 16, testament: 'NT' },
    { id: 'luke', name: 'Luke', abbrev: 'Luke', chapters: 24, testament: 'NT' },
    { id: 'john', name: 'John', abbrev: 'John', chapters: 21, testament: 'NT' },
    { id: 'acts', name: 'Acts', abbrev: 'Acts', chapters: 28, testament: 'NT' },
    { id: 'romans', name: 'Romans', abbrev: 'Rom', chapters: 16, testament: 'NT' },
    { id: '1corinthians', name: '1 Corinthians', abbrev: '1 Cor', chapters: 16, testament: 'NT' },
    { id: '2corinthians', name: '2 Corinthians', abbrev: '2 Cor', chapters: 13, testament: 'NT' },
    { id: 'galatians', name: 'Galatians', abbrev: 'Gal', chapters: 6, testament: 'NT' },
    { id: 'ephesians', name: 'Ephesians', abbrev: 'Eph', chapters: 6, testament: 'NT' },
    { id: 'philippians', name: 'Philippians', abbrev: 'Phil', chapters: 4, testament: 'NT' },
    { id: 'colossians', name: 'Colossians', abbrev: 'Col', chapters: 4, testament: 'NT' },
    { id: '1thessalonians', name: '1 Thessalonians', abbrev: '1 Thess', chapters: 5, testament: 'NT' },
    { id: '2thessalonians', name: '2 Thessalonians', abbrev: '2 Thess', chapters: 3, testament: 'NT' },
    { id: 'revelation', name: 'Revelation', abbrev: 'Rev', chapters: 22, testament: 'NT' },
  ]
};

// Bible Versions/Translations
export const BIBLE_VERSIONS = [
  { id: 'kjv', name: 'King James Version', abbrev: 'KJV' },
  { id: 'nkjv', name: 'New King James Version', abbrev: 'NKJV' },
  { id: 'niv', name: 'New International Version', abbrev: 'NIV' },
  { id: 'esv', name: 'English Standard Version', abbrev: 'ESV' },
  { id: 'nlt', name: 'New Living Translation', abbrev: 'NLT' },
];

// Languages
export const BIBLE_LANGUAGES = [
  { id: 'en', name: 'English', flag: '🇬🇧' },
  { id: 'lg', name: 'Luganda', flag: '🇺🇬' },
];

// Mock Bible Verses (Genesis 1 as example)
export const MOCK_BIBLE_DATA = {
  genesis: {
    1: {
      kjv: [
        { verse: 1, text: "In the beginning God created the heaven and the earth." },
        { verse: 2, text: "And the earth was without form, and void; and darkness was upon the face of the deep. And the Spirit of God moved upon the face of the waters." },
        { verse: 3, text: "And God said, Let there be light: and there was light." },
        { verse: 4, text: "And God saw the light, that it was good: and God divided the light from the darkness." },
        { verse: 5, text: "And God called the light Day, and the darkness he called Night. And the evening and the morning were the first day." },
        { verse: 6, text: "And God said, Let there be a firmament in the midst of the waters, and let it divide the waters from the waters." },
        { verse: 7, text: "And God made the firmament, and divided the waters which were under the firmament from the waters which were above the firmament: and it was so." },
        { verse: 8, text: "And God called the firmament Heaven. And the evening and the morning were the second day." },
      ],
      lg: [
        { verse: 1, text: "Mu kutandika Katonda yatonda eggulu n\'ensi." },
        { verse: 2, text: "Ensi yali njereere era nga njereere; n\'ekizikiza kyali ku maaso g\'ebuziba. Omwoyo gwa Katonda ne gwetambula waggulu w\'amazzi." },
        { verse: 3, text: "Katonda n'agamba nti, Ekitangaala kibeerewo: ekitangaala ne kiba." },
        { verse: 4, text: "Katonda n\'alaba ekitangaala nga kirungi: Katonda n\'ayawula ekitangaala n\'ekizikiza." },
        { verse: 5, text: "Katonda n'atuuma ekitangaala Emisana, n'ekizikiza n'akituuma Ekiro. Olwaggulo ne lukya ne luba olunaku olw'olubereberye." },
      ]
    }
  },
  john: {
    1: {
      kjv: [
        { verse: 1, text: "In the beginning was the Word, and the Word was with God, and the Word was God." },
        { verse: 2, text: "The same was in the beginning with God." },
        { verse: 3, text: "All things were made by him; and without him was not any thing made that was made." },
        { verse: 4, text: "In him was life; and the life was the light of men." },
        { verse: 5, text: "And the light shineth in darkness; and the darkness comprehended it not." },
      ]
    },
    3: {
      kjv: [
        { verse: 16, text: "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life." },
        { verse: 17, text: "For God sent not his Son into the world to condemn the world; but that the world through him might be saved." },
      ]
    }
  },
  matthew: {
    5: {
      kjv: [
        { verse: 1, text: "And seeing the multitudes, he went up into a mountain: and when he was set, his disciples came unto him:" },
        { verse: 2, text: "And he opened his mouth, and taught them, saying," },
        { verse: 3, text: "Blessed are the poor in spirit: for theirs is the kingdom of heaven." },
        { verse: 4, text: "Blessed are they that mourn: for they shall be comforted." },
        { verse: 5, text: "Blessed are the meek: for they shall inherit the earth." },
      ]
    }
  }
};

// Book Introductions & Outlines
export const BOOK_INTRODUCTIONS = {
  genesis: {
    author: "Moses",
    date: "c. 1445-1405 BC",
    theme: "Beginnings",
    purpose: "To record God\'s creation of the world and His desire to have a people set apart to worship Him.",
    outline: [
      { section: "I", title: "Primeval History (1:1-11:26)", subsections: [
        "A. Creation (1:1-2:25)",
        "B. Fall (3:1-24)",
        "C. Flood (6:1-9:29)",
        "D. Nations (10:1-11:26)"
      ]},
      { section: "II", title: "Patriarchal History (11:27-50:26)", subsections: [
        "A. Abraham (11:27-25:18)",
        "B. Isaac (25:19-26:35)",
        "C. Jacob (27:1-36:43)",
        "D. Joseph (37:1-50:26)"
      ]}
    ]
  },
  john: {
    author: "John the Apostle",
    date: "c. AD 85-95",
    theme: "Jesus is the Son of God",
    purpose: "That you may believe that Jesus is the Christ, the Son of God, and that believing you may have life in His name.",
    outline: [
      { section: "I", title: "Prologue (1:1-18)" },
      { section: "II", title: "Public Ministry (1:19-12:50)" },
      { section: "III", title: "Private Ministry (13:1-17:26)" },
      { section: "IV", title: "Passion Narrative (18:1-19:42)" },
      { section: "V", title: "Resurrection (20:1-31)" },
      { section: "VI", title: "Epilogue (21:1-25)" }
    ]
  },
  matthew: {
    author: "Matthew (Levi)",
    date: "c. AD 50-70",
    theme: "Jesus the Messiah-King",
    purpose: "To present Jesus as the promised Messiah and King of Israel.",
    outline: [
      { section: "I", title: "Birth and Preparation (1:1-4:11)" },
      { section: "II", title: "Galilean Ministry (4:12-18:35)" },
      { section: "III", title: "Journey to Jerusalem (19:1-20:34)" },
      { section: "IV", title: "Passion Week (21:1-27:66)" },
      { section: "V", title: "Resurrection (28:1-20)" }
    ]
  }
};

// Treasury of Scripture Knowledge (TSK) Cross-References
export const TSK_CROSS_REFERENCES = {
  'genesis-1-1': [
    { reference: 'John 1:1', text: 'In the beginning was the Word...' },
    { reference: 'Hebrews 11:3', text: 'By faith we understand that the worlds were framed...' },
    { reference: 'Psalm 33:6', text: 'By the word of the LORD were the heavens made...' },
  ],
  'genesis-1-3': [
    { reference: '2 Corinthians 4:6', text: 'For God, who commanded the light to shine...' },
    { reference: 'Psalm 33:9', text: 'For he spake, and it was done...' },
  ],
  'john-1-1': [
    { reference: 'Genesis 1:1', text: 'In the beginning God created...' },
    { reference: 'Proverbs 8:22-23', text: 'The LORD possessed me in the beginning...' },
    { reference: '1 John 1:1', text: 'That which was from the beginning...' },
  ],
  'john-3-16': [
    { reference: 'Romans 5:8', text: 'But God commendeth his love toward us...' },
    { reference: '1 John 4:9', text: 'In this was manifested the love of God...' },
    { reference: 'Romans 8:32', text: 'He that spared not his own Son...' },
  ]
};

// Experiencing Christ Commentary
export const EXPERIENCING_CHRIST_COMMENTARY = {
  'genesis-1-1': {
    title: "The Beginning of All Things",
    content: "This opening verse reveals the eternal God who exists before all creation. The Hebrew word 'Elohim' emphasizes God's power and majesty. Creation begins with God, not with matter or chance. Everything that exists has its origin in the divine Creator.",
    application: "Just as God created all things in the beginning, He desires to create new life in us through Christ (2 Cor 5:17).",
    prayRead: "Father, You are the source of all life. Create in me a clean heart and renew a right spirit within me.",
    prayReadExtended: {
      introduction: "Pray-reading is a powerful way to internalize God's Word. Take this verse slowly, phrase by phrase, turning it into prayer.",
      steps: [
        "Read the verse aloud slowly: \'In the beginning God created the heaven and the earth.'",
        "Pray with the first phrase: 'Father, You are the beginning of all things. Before anything existed, You were there.'",
        "Continue with creation: \'You created the heavens and earth by Your Word. You spoke and it came into being.'",
        "Personalize it: 'Just as You created all things in the beginning, create newness in my life today.'",
        "End with worship: 'You are the eternal Creator, the source of all life. I worship You!'"
      ],
      reflection: "As you pray-read this verse, allow the reality of God as Creator to fill your heart. He who created everything has the power to create new things in your life.",
      relatedVerses: [
        { ref: "2 Corinthians 5:17", text: "Therefore if any man be in Christ, he is a new creature..." },
        { ref: "Psalm 51:10", text: "Create in me a clean heart, O God..." }
      ]
    }
  },
  'john-1-1': {
    title: "The Eternal Word",
    content: "John opens his gospel by identifying Jesus as the eternal Word (Logos) who existed from the beginning with God and was God. This Word is not merely spoken words, but the living expression of God Himself - Jesus Christ.",
    application: "Christ is not just a teacher or prophet, but God Himself made manifest. In Him we see the fullness of deity dwelling in bodily form (Col 2:9).",
    prayRead: "Lord Jesus, You are the eternal Word who became flesh. Reveal Yourself to me as the living expression of God.",
    prayReadExtended: {
      introduction: "This verse reveals the divine nature of Christ. Pray-read it to encounter Jesus as the eternal Word.",
      steps: [
        "Begin with the eternal nature: 'Lord Jesus, You were in the beginning. Before time, You existed with the Father.'",
        "Acknowledge His deity: 'You were with God, and You were God. You are fully divine.'",
        "Worship Him as the Word: 'You are the living Word, the expression of God to humanity.'",
        "Invite His revelation: \'Reveal Yourself to me today as the eternal Word made flesh.'",
        "Close with faith: \'I believe You are God. I receive You as my Lord and Savior.'"
      ],
      reflection: "As you pray this verse, allow the profound truth of Christ's eternal deity to fill your being. He is not a created being, but the eternal God who became flesh.",
      relatedVerses: [
        { ref: "John 1:14", text: "And the Word was made flesh, and dwelt among us..." },
        { ref: "Colossians 1:15", text: "Who is the image of the invisible God..." }
      ]
    }
  },
  'john-3-16': {
    title: "God\'s Supreme Love",
    content: "This verse captures the heart of the gospel - God's love demonstrated through the gift of His Son. The phrase 'so loved' indicates the intensity and measure of God's love. The gift of eternal life is available to all who believe.",
    application: "God's love is not based on our worthiness but on His nature. Believing in Christ means trusting Him completely for salvation and eternal life.",
    prayRead: "Father, thank You for loving the world so much that You gave Your only Son. I believe in Him for eternal life.",
    prayReadExtended: {
      introduction: "This is perhaps the most beloved verse in Scripture. Pray-read it to deeply experience God\'s love.",
      steps: [
        "Begin with God's love: 'Father, You so loved the world. Your love is beyond measure.'",
        "Thank Him for the gift: 'You gave Your only begotten Son. Thank You for this supreme sacrifice.'",
        "Embrace the promise: 'Whoever believes in Him shall not perish. I believe, Lord!'",
        "Receive eternal life: 'I receive Your gift of eternal life through faith in Jesus.'",
        "Respond in worship: \'Your love overwhelms me. I love You because You first loved me.'"
      ],
      reflection: "As you pray-read, let the magnitude of God's love sink deep into your heart. He loved you enough to give His most precious treasure.",
      relatedVerses: [
        { ref: "Romans 5:8", text: "But God commendeth his love toward us..." },
        { ref: "1 John 4:9-10", text: "In this was manifested the love of God..." }
      ]
    }
  }
};

// Word-by-Word Commentary Data
export const WORD_COMMENTARY = {
  'genesis-1-1-beginning': {
    word: "beginning",
    hebrew: "רֵאשִׁית (reshiyth)",
    strongs: "H7225",
    transliteration: "reshiyth",
    partOfSpeech: "noun feminine",
    definition: "The first, in place, time, order or rank; the beginning, the first fruits",
    explanation: "This word indicates the starting point of all creation. It doesn't specify when this beginning was, but establishes that there was a definite commencement point for the physical universe.",
    morphology: {
      gender: "feminine",
      number: "singular",
      state: "absolute"
    },
    supportingVerses: [
      { ref: 'Proverbs 8:22', text: 'The LORD possessed me in the beginning of his way...' },
      { ref: 'John 1:1', text: 'In the beginning was the Word...' },
      { ref: 'Colossians 1:18', text: 'He is the beginning, the firstborn from the dead...' }
    ]
  },
  'genesis-1-1-god': {
    word: "God",
    hebrew: "אֱלֹהִים (Elohim)",
    strongs: "H430",
    transliteration: "Elohim",
    partOfSpeech: "noun masculine plural",
    definition: "Gods, judges, angels; the supreme God",
    explanation: "Elohim is a plural form but used with singular verbs, suggesting the majesty and fullness of the Godhead. This name emphasizes God's power and might as Creator.",
    morphology: {
      gender: "masculine",
      number: "plural",
      form: "intensive plural (plural of majesty)"
    },
    supportingVerses: [
      { ref: 'Deuteronomy 6:4', text: 'Hear, O Israel: The LORD our God is one LORD' },
      { ref: 'Isaiah 45:18', text: 'For thus saith the LORD that created the heavens; God himself...' },
      { ref: 'Jeremiah 10:10', text: 'But the LORD is the true God, he is the living God...' }
    ]
  },
  'john-1-1-word': {
    word: "Word",
    greek: "λόγος (logos)",
    strongs: "G3056",
    transliteration: "logos",
    partOfSpeech: "noun masculine",
    definition: "Word, speech, divine utterance, analogy; the divine expression",
    explanation: "Logos refers to divine reason, the creative and governing principle of the universe. John uses this term to identify Jesus as the eternal expression and revelation of God - not just God's message, but God Himself expressed.",
    morphology: {
      gender: "masculine",
      number: "singular",
      case: "nominative"
    },
    supportingVerses: [
      { ref: 'Revelation 19:13', text: 'His name is called The Word of God' },
      { ref: 'Hebrews 1:2', text: 'Hath in these last days spoken unto us by his Son...' },
      { ref: '1 John 1:1', text: 'The Word of life...' }
    ]
  }
};

// Helper function to get book by ID
export const getBookById = (bookId) => {
  const allBooks = [...BIBLE_BOOKS?.oldTestament, ...BIBLE_BOOKS?.newTestament];
  return allBooks?.find(book => book?.id === bookId?.toLowerCase());
};

// Helper function to get verses
export const getVerses = (bookId, chapter, version = 'kjv', language = 'en') => {
  const book = MOCK_BIBLE_DATA?.[bookId?.toLowerCase()];
  if (!book || !book?.[chapter]) {
    return [];
  }
  
  const versionKey = language === 'lg' ? 'lg' : version?.toLowerCase();
  return book?.[chapter]?.[versionKey] || book?.[chapter]?.['kjv'] || [];
};

// Helper function to get cross-references
export const getCrossReferences = (bookId, chapter, verse) => {
  const key = `${bookId}-${chapter}-${verse}`;
  return TSK_CROSS_REFERENCES?.[key] || [];
};

// Helper function to get commentary
export const getCommentary = (bookId, chapter, verse) => {
  const key = `${bookId}-${chapter}-${verse}`;
  return EXPERIENCING_CHRIST_COMMENTARY?.[key] || null;
};

// Helper function to get book introduction
export const getBookIntroduction = (bookId) => {
  return BOOK_INTRODUCTIONS?.[bookId?.toLowerCase()] || null;
};

// Helper function to search verses (mock implementation)
export const searchVerses = (query, version = 'kjv') => {
  const results = [];
  const queryLower = query?.toLowerCase();
  
  Object.keys(MOCK_BIBLE_DATA)?.forEach(bookId => {
    const book = MOCK_BIBLE_DATA?.[bookId];
    Object.keys(book)?.forEach(chapter => {
      const verses = book?.[chapter]?.[version] || book?.[chapter]?.['kjv'];
      verses?.forEach(verse => {
        if (verse?.text?.toLowerCase()?.includes(queryLower)) {
          const bookInfo = getBookById(bookId);
          results?.push({
            book: bookInfo?.name,
            bookId,
            chapter: parseInt(chapter),
            verse: verse?.verse,
            text: verse?.text
          });
        }
      });
    });
  });
  
  return results;
};

// Helper function to get word commentary
export const getWordCommentary = (bookId, chapter, verse, wordId) => {
  const key = `${bookId}-${chapter}-${verse}-${wordId}`;
  return WORD_COMMENTARY?.[key] || null;
};

// Helper function to get all words in a verse for word-by-word study
export const getVerseWords = (bookId, chapter, verse) => {
  // Mock implementation - in real app, this would parse the verse and return word IDs
  const verseKey = `${bookId}-${chapter}-${verse}`;
  
  if (bookId === 'genesis' && chapter === 1 && verse === 1) {
    return [
      { id: 'beginning', word: 'beginning', order: 1 },
      { id: 'god', word: 'God', order: 2 },
      { id: 'created', word: 'created', order: 3 }
    ];
  }
  
  if (bookId === 'john' && chapter === 1 && verse === 1) {
    return [
      { id: 'beginning', word: 'beginning', order: 1 },
      { id: 'word', word: 'Word', order: 2 }
    ];
  }
  
  return [];
};